"use strict";

var mapping;
var layout;

// TODO ?
module.exports = {mapping, layout};

var React = require('react');
var ReactForms = require('react-forms');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;
var interpolate = i18n.interpolate;

var settings = require('ofs/settings');

var Scalar = require('ofs/forms/scalars/Scalar');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var messages = {
  FIRST_NAME_LABEL: gettext('First name'),
  LAST_NAME_LABEL: gettext('Second name'),
  COMPANY_LABEL: gettext('Company'),
  INTRO_PARAGRAPH: gettext('Before filling this out have you seen our <a href="%(jobs_url)s">jobs page</a>, <a href="%(partners_url)s">partners page</a>, <a href="%(press_url)s">press room page</a> and page for <a href="%(international_url)s">international launch</a>?</p>'),
  INTRO_HEADING: gettext('Need to ask something else?'),
  FOOTER_MESSAGE: gettext('Alternatively, contact us directly')
};


var mapping = function(defaultValues) {
  return {
    first_name: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('firstName', null),
      label: messages.FIRST_NAME_LABEL
    }),
    last_name: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('lastName', null),
      label: messages.LAST_NAME_LABEL
    }),
    company: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('company', null),
      label: messages.COMPANY_LABEL
    })
  };
};

var layout = function(value) {
  var msg = interpolate(messages.INTRO_PARAGRAPH, {
    jobs_url: settings.urls.jobs,
    partners_url: settings.urls.partners,
    press_url: settings.urls.press,
    international_url: settings.urls.international
  }, true);

  return (
    <Group>
      <Row>
        <Column size="full">
          <p dangerouslySetInnerHTML={{__html: msg}} />
          <h3>{messages.INTRO_HEADING}</h3>
        </Column>
      </Row>
      <Row>
        <Column size="half"><FormElement value={value.get('first_name')} /></Column>
        <Column size="half"><FormElement value={value.get('last_name')} /></Column>
      </Row>
      <Row>
        <Column size="full"><FormElement value={value.get('company')} /></Column>
      </Row>
    </Group>
  );
};

var Footer = React.createClass({
  render() {
    var emailAddress = 'info@onefinestay.com';
    var emailUrl = `mailto:${ emailAddress }`;

    return (
      <div className="ofs-InfoPanel u-text-center">
        <p>{messages.FOOTER_MESSAGE}</p>
        <p><a href={emailUrl}>{emailAddress}</a></p>
      </div>
    );
  }
});

module.exports = {mapping, layout, Footer};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/general.jsx
 **/